import axiosInstance from '../utilities/axiosInstance';

const tokenUsageAPI = {
  getSummary: async (userRole) => {
    try {
      const response = await axiosInstance.get('/api/tokens/summary', {
        params: { userRole }
      });
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: `Failed to fetch token summary: ${error.response?.data?.error || error.message}`
      };
    }
  },

  getRecent: async (limit = 20) => {
    try {
      const response = await axiosInstance.get('/api/tokens/recent', {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: `Failed to fetch recent token usage: ${error.response?.data?.error || error.message}`
      };
    }
  },

  getAdminReport: async (filters = {}) => {
    try {
      const response = await axiosInstance.get('/api/tokens/admin-report', {
        params: filters
      });
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: `Failed to fetch admin token report: ${error.response?.data?.error || error.message}`
      };
    }
  }
};

export default tokenUsageAPI;